<template>
  <div class="experience">
    <h4 data-aos="fade-up">Experience</h4>    
    <v-app>
    <div class="row">
      <div class="col-12 col-sm-6">

        <div class="left"
        data-aos="fade-right"
        >
          <h2>.Net</h2>

        <v-card
          v-for="item in net" :key="item.name"
        class="tech"
        >
          <v-card-text >
            <div>{{ item.name }}</div>
          </v-card-text>
        </v-card>
        </div>

        <div class="left"
        data-aos="fade-right"
        >
          <h2>Tools</h2>
        <v-card
          v-for="item in tools" :key="item.name"
        class="tech"
        >
          <v-card-text >
            <div>{{ item.name }}</div>
          </v-card-text>
        </v-card>
          
        </div>

      </div>

      <div class="col-12 col-sm-6">
        <div class="right"
        data-aos="fade-left"
        >
        <h2>JAVASCRIPT</h2>

        <v-card
          v-for="item in js" :key="item.name"
        class="tech"
        >
          <v-card-text >
            <div>{{ item.name }}</div>
          </v-card-text>
        </v-card>

        </div>

        <div class="right"
        data-aos="fade-left"
        >
        <h2>Other</h2>        
        <v-card
          v-for="item in other" :key="item.name"
        class="tech"
        >
          <v-card-text >
            <div>{{ item.name }}</div>
          </v-card-text>
        </v-card>
        </div>
      </div>
    </div>
  </v-app>

  </div>
</template>

<script>
export default {
  name: 'Experience',
  props: {
    
  },
  data () {
      return {
        net: [
        { name: "C#" },
        { name: "VB.Net" },
        { name: "Entity Framework" },
        { name: "MVC" },
        { name: "SQL Server" },
        { name: "Win Forms" },
        { name: "Web API" },
        { name: "MSTest" }
    ],
    tools: [
        { name: "Visual Studio" },
        { name: "VSCode" },
        { name: "SSMS" },
        { name: "Jira" },
        { name: "Service Desk" },
        { name: "IIS" },
        { name: "Postman" }
    ],
    js: [
        { name: "Vue.js" },
        { name: "Node.js" },
        { name: "GraphQL" },
        { name: "jQuery" },
        { name: "JSON / XML" },
        { name: "Jest" },
        { name: "AJAX" },
        { name: "Vuetify" }
    ],
    other: [
        { name: "Git" },
        { name: "TFS" },
        { name: "Subversion" },
        { name: "Azure" },
        { name: "Cucumber" },
        { name: "Sirecore" },
        { name: "Wordpress" }        
    ],
      }
    }
}
</script>

<style scoped>
.experience{
  background-color: #3782d2;
  color: #fff;
  overflow: hidden;  
  padding-bottom: 50px;
}
.v-alert{
 background-color: #2664a6!important;
 color: #fff!important;
}
.row{
  background-color: #3782d2;
}
.v-list-item{
  background-color: #3782d2;
}
.left{
  /* float: right; */
  background-color: #2664a6!important;
  /* min-width: 80%;
  max-width: 600px; */
  border-radius: 10px;
  margin-bottom: 30px;  
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
    padding-top: 20px;
    margin-left: 30px;
    margin-right: 30px;
}

.right{
  /* float: left; */
  background-color: #2664a6!important;
  /* min-width: 80%;
  max-width: 600px; */
  border-radius: 10px;
  margin-bottom: 30px;  
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
    padding-bottom: 30px;
    padding-top: 20px;
    margin-left: 30px;
    margin-right: 30px;
}
h2{
  color: #fff!important;
  margin: 20px;
}
ul{list-style: none}
li{
font-family: 'Balsamiq Sans', cursive;
 color: #fff;
 font-size: 18px;
 margin:10px;
 text-align: left;
}
.tech{
  border-radius: 50px 50px 50px 50px!important;  
  width: max-content;
  display: inline-block;
  margin: 10px;
  padding: 10px;
  background-color: #3782d2!important;
  color: #fff!important;
  }
  .v-card__text{
  color: #fff!important;
  padding: 5px;
  }
</style>
